import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _extends from 'babel-runtime/helpers/extends';
import React, { Component } from 'react';
import { mergeStyles } from 'react-select';
import { colors } from '@atlaskit/theme';

import * as animatedComponents from 'react-select/lib/animated';
import * as defaultComponents from './components';

// NOTE in the future, `Props` and `defaultProps` should come
// directly from react-select

function baseStyles(validationState) {
  return {
    control: function control(css, _ref) {
      var isFocused = _ref.isFocused,
          isDisabled = _ref.isDisabled;

      var borderColor = isFocused ? colors.B100 : colors.N10;
      var backgroundColor = isFocused ? colors.N0 : colors.N10;
      if (isDisabled) {
        backgroundColor = colors.N20;
      }
      if (validationState === 'error') borderColor = colors.R400;
      if (validationState === 'success') borderColor = colors.G400;

      var borderColorHover = isFocused ? colors.B100 : colors.N20;
      if (validationState === 'error') borderColorHover = colors.R400;
      if (validationState === 'success') borderColorHover = colors.G400;

      var lgBorder = isFocused || validationState !== 'default';
      var transitionDuration = '200ms';

      return _extends({}, css, {
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderWidth: lgBorder ? 2 : 1,
        boxShadow: 'none',
        minHeight: '32px',
        padding: lgBorder ? 0 : 1,
        transition: 'background-color ' + transitionDuration + ' ease-in-out,\n        border-color ' + transitionDuration + ' ease-in-out',

        ':hover': {
          backgroundColor: isFocused ? colors.N0 : colors.N20,
          borderColor: borderColorHover
        }
      });
    },
    dropdownIndicator: function dropdownIndicator(css, _ref2) {
      var isDisabled = _ref2.isDisabled;

      var color = colors.N500;
      if (isDisabled) {
        color = colors.N70;
      }
      return _extends({}, css, {
        color: color,
        paddingBottom: 6,
        paddingTop: 6,

        ':hover': {
          color: colors.N200
        }
      });
    },
    option: function option(css, _ref3) {
      var isFocused = _ref3.isFocused,
          isSelected = _ref3.isSelected;

      var color = isSelected ? colors.N0 : null;

      var backgroundColor = void 0;
      if (isSelected) backgroundColor = colors.N200;else if (isFocused) backgroundColor = colors.N20;

      return _extends({}, css, { backgroundColor: backgroundColor, color: color });
    },
    placeholder: function placeholder(css) {
      return _extends({}, css, { color: colors.N70 });
    },
    singleValue: function singleValue(css, _ref4) {
      var isDisabled = _ref4.isDisabled;
      return _extends({}, css, {
        color: isDisabled ? colors.N70 : colors.N900
      });
    }
  };
}

export default function createSelect(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits(AtlaskitSelect, _Component);

    function AtlaskitSelect(props) {
      _classCallCheck(this, AtlaskitSelect);

      var _this = _possibleConstructorReturn(this, (AtlaskitSelect.__proto__ || _Object$getPrototypeOf(AtlaskitSelect)).call(this, props));

      _this.cacheComponents = function (components) {
        _this.components = _extends({}, defaultComponents, animatedComponents, components);
      };

      _this.onSelectRef = function (ref) {
        _this.select = ref;
      };

      _this.cacheComponents(props.components);
      return _this;
    }

    _createClass(AtlaskitSelect, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.components !== this.props.components) {
          this.cacheComponents(nextProps.components);
        }
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'render',
      value: function render() {
        // $FlowFixMe: `validationState` is passed in from a parent validation component
        var _props = this.props,
            styles = _props.styles,
            validationState = _props.validationState,
            props = _objectWithoutProperties(_props, ['styles', 'validationState']); // eslint-disable-line

        // props must be spread first to stop `components` being overridden


        return React.createElement(WrappedComponent, _extends({
          ref: this.onSelectRef
        }, props, {
          components: this.components,
          styles: mergeStyles(baseStyles(validationState), styles)
        }));
      }
    }]);

    return AtlaskitSelect;
  }(Component), _class.defaultProps = { validationState: 'default' }, _temp;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/select/dist/esm/createSelect.js
// module id = 71
// module chunks = 0